'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.rentalProductOverviewItem = rentalProductOverviewItem;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function rentalProductOverviewItem() {
    var clazz = function RentalProductOverviewItem() {
        var defaults = {
            id: null,
            name: '',
            discountName: '',
            displayName: '',
            message: null,
            type: '',
            image: '',
            sellerId: 0,
            sellerName: '',
            price: 0,
            nationalNumber: 0,
            rentalDeposit: 0,
            sellerBaseCodeId: 0,
            relationTypeCode: 0,
            quantity: 0,
            vat: 0,
            order: false,
            rentedFrom: null,
            pharmacyPrice: 0,
            deliveryByExternalPartner: false,
            isSellable: false
        };

        _lodash2.default.extend(this, defaults);
    };

    _lodash2.default.extend(clazz.prototype, {
        toJSON: function toJSON() {
            return {
                productId: this.id,
                quantity: this.quantity
            };
        },

        calculateTotalRent: function calculateTotalRent() {
            var startDay = (0, _moment2.default)(this.rentedFrom, 'YYYY-MM-DD');
            var endDay = (0, _moment2.default)().startOf('day');
            if (startDay.isSame(endDay)) {
                return 0;
            }
            var daysBetween = endDay.diff(startDay, 'days') + 1; // =1
            return daysBetween * this.dayPrice;
        }
    });

    clazz.create = function (resource) {
        var productOverview = new clazz();
        productOverview.id = resource.productId;
        productOverview.name = resource.productName;
        productOverview.displayName = resource.productName;
        productOverview.imagePath = resource.imagePath;
        productOverview.sellerId = resource.sellerId;
        productOverview.sellerName = resource.sellerName;
        productOverview.nationalNumber = resource.nationalNumber;
        productOverview.dayPrice = resource.dayPrice;
        productOverview.price = resource.dayPrice;
        productOverview.vat = resource.vat;
        productOverview.rentalDeposit = resource.rentalDeposit;
        productOverview.sellerBaseCodeId = resource.sellerBaseCodeId;
        productOverview.relationTypeCode = resource.relationTypeCode;
        productOverview.rentedFrom = resource.rentedFrom;
        productOverview.productTypeCode = resource.productTypeCode;
        productOverview.pharmacyPrice = resource.pharmacyPrice;
        productOverview.publicPrice = resource.publicPrice;
        productOverview.deliveryByExternalPartner = resource.deliveryByExternalPartner;
        productOverview.isSellable = resource.isSellable;
        if (productOverview.rentedFrom && productOverview.price) {
            productOverview.totalRent = productOverview.calculateTotalRent();
        }
        return productOverview;
    };

    return clazz;
}


//////////////////
// WEBPACK FOOTER
// ./common/models/rentalProductOverviewItemModel.js
// module id = 785
// module chunks = 0